<template functional>
  <tr
    :class="props.row.showCombined ? 'color-row' : ''"
    v-bind="data.attrs"
  >
    <slot />
  </tr>
</template>

<script>
export default {
  name: 'DatasetRow',
  props: {
    columns: { type: Array, default: () => [] },
    row: { type: Object, default: () => ({}) },
  },
}
</script>
<style lang="scss">
@import '@/style/inject';
.color-row{
  background-color: rgba( $primary, .7 );
}
.color-row:hover{
  background-color: rgba( $primary, .8 ) !important;
}
</style>